var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import AElf from 'aelf-sdk';
import { sleep } from '@portkey/utils';
import { aelf } from '@portkey/utils';
import { AElfCAContract } from '../caContract.js';
import { ContractBasic } from '../contract.js';
const methodsMap = {};
export const getContractBasic = (options) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const { contractAddress, chainType = 'aelf', callType = 'eoa' } = options;
    if (chainType === 'ethereum')
        throw new Error('Not yet supported');
    // use provider
    if ('chainProvider' in options) {
        const { chainProvider } = options;
        return chainProvider.getContract(contractAddress);
    }
    const { aelfInstance, rpcUrl, account, extraOptions } = options;
    let instance = aelfInstance;
    if (rpcUrl)
        instance = aelf.getAelfInstance(rpcUrl);
    if (!instance)
        throw new Error('Get instance error');
    const contractOptions = {
        type: chainType,
        contractAddress,
        aelfInstance: instance,
        rpcUrl: ((_a = instance === null || instance === void 0 ? void 0 : instance.currentProvider) === null || _a === void 0 ? void 0 : _a.host) || 'host',
    };
    const contractInitOption = { refBlockNumberStrategy: extraOptions === null || extraOptions === void 0 ? void 0 : extraOptions.refBlockNumberStrategy };
    // use ca contract
    if (callType === 'ca') {
        const { caContractAddress, caHash } = options;
        const [aelfContract, caContract] = yield Promise.all([
            instance.chain.contractAt(contractAddress, account, contractInitOption),
            instance.chain.contractAt(caContractAddress, account, contractInitOption),
        ]);
        return new AElfCAContract(Object.assign(Object.assign({}, contractOptions), { caHash,
            caContract,
            aelfContract,
            caContractAddress }));
    }
    const aelfContract = yield instance.chain.contractAt(contractAddress, account, contractInitOption);
    // use basic contract
    return new ContractBasic(Object.assign(Object.assign({}, contractOptions), { aelfContract }));
});
export function handleGetTxResult(instance) {
    return instance.getTxResult ? instance.getTxResult : instance.chain.getTxResult;
}
export class TXError extends Error {
    constructor(message, id) {
        super(message);
        this.TransactionId = id;
        this.transactionId = id;
    }
}
export function handleContractErrorMessage(error) {
    if (typeof error === 'string')
        return error;
    if (error === null || error === void 0 ? void 0 : error.message)
        return error.message;
    if (error.Error) {
        return error.Error.Details || error.Error.Message || error.Error;
    }
    return `Transaction: ${error.Status}`;
}
export function getTxResult(instance, TransactionId, reGetCount = 0, notExistedReGetCount = 0) {
    return __awaiter(this, void 0, void 0, function* () {
        const txFun = handleGetTxResult(instance);
        let txResult;
        try {
            txResult = yield txFun(TransactionId);
        }
        catch (error) {
            throw new TXError(handleContractErrorMessage(error), TransactionId);
        }
        if ((txResult === null || txResult === void 0 ? void 0 : txResult.error) && (txResult === null || txResult === void 0 ? void 0 : txResult.errorMessage)) {
            throw new TXError(txResult.errorMessage.message || txResult.errorMessage.Message, TransactionId);
        }
        const result = (txResult === null || txResult === void 0 ? void 0 : txResult.result) || txResult;
        if (!result)
            throw new TXError('Can not get transaction result.', TransactionId);
        const lowerCaseStatus = result.Status.toLowerCase();
        if (lowerCaseStatus === 'notexisted') {
            if (notExistedReGetCount > 5)
                throw new TXError(result.Error || `Transaction: ${result.Status}`, TransactionId);
            yield sleep(1000);
            notExistedReGetCount++;
            reGetCount++;
            return getTxResult(instance, TransactionId, reGetCount, notExistedReGetCount);
        }
        if (lowerCaseStatus === 'pending' || lowerCaseStatus === 'pending_validation') {
            if (reGetCount > 20)
                throw new TXError(result.Error || `Transaction: ${result.Status}`, TransactionId);
            yield sleep(1000);
            reGetCount++;
            return getTxResult(instance, TransactionId, reGetCount, notExistedReGetCount);
        }
        if (lowerCaseStatus === 'mined')
            return result;
        throw new TXError(result.Error || `Transaction: ${result.Status}`, TransactionId);
    });
}
export function handleContractError(error, req) {
    var _a, _b, _c, _d, _e;
    if (typeof error === 'string')
        return { message: error };
    if (error === null || error === void 0 ? void 0 : error.message)
        return error;
    if (error === null || error === void 0 ? void 0 : error.Error) {
        return {
            message: error.Error.Details || error.Error.Message || error.Error || error.Status,
            code: error.Error.Code,
        };
    }
    return {
        code: ((_b = (_a = req === null || req === void 0 ? void 0 : req.error) === null || _a === void 0 ? void 0 : _a.message) === null || _b === void 0 ? void 0 : _b.Code) || (req === null || req === void 0 ? void 0 : req.error),
        message: ((_c = req === null || req === void 0 ? void 0 : req.errorMessage) === null || _c === void 0 ? void 0 : _c.message) || ((_e = (_d = req === null || req === void 0 ? void 0 : req.error) === null || _d === void 0 ? void 0 : _d.message) === null || _e === void 0 ? void 0 : _e.Message),
    };
}
export function handleFunctionName(functionName) {
    return functionName.replace(functionName[0], functionName[0].toLocaleUpperCase());
}
export const getServicesFromFileDescriptors = (descriptors) => {
    const root = AElf.pbjs.Root.fromDescriptor(descriptors, 'proto3').resolveAll();
    return descriptors.file
        .filter((f) => f.service.length > 0)
        .map((f) => {
        const sn = f.service[0].name;
        const fullName = f.package ? `${f.package}.${sn}` : sn;
        return root.lookupService(fullName);
    });
};
export const getFileDescriptorsSet = (instance, contractAddress) => __awaiter(void 0, void 0, void 0, function* () {
    const fds = yield instance.chain.getContractFileDescriptorSet(contractAddress);
    return getServicesFromFileDescriptors(fds);
});
export function getContractMethods(instance, address) {
    return __awaiter(this, void 0, void 0, function* () {
        const key = instance.currentProvider.host + address;
        if (!methodsMap[key]) {
            const methods = yield getFileDescriptorsSet(instance, address);
            const _obj = {};
            Object.keys(methods).forEach(key => {
                const service = methods[key];
                Object.keys(service.methods).forEach(key => {
                    const method = service.methods[key].resolve();
                    _obj[method.name] = method.resolvedRequestType;
                });
            });
            methodsMap[key] = _obj;
        }
        return methodsMap[key];
    });
}
export const encodedParams = (inputType, params) => __awaiter(void 0, void 0, void 0, function* () {
    let input = AElf.utils.transform.transformMapToArray(inputType, params);
    input = AElf.utils.transform.transform(inputType, input, AElf.utils.transform.INPUT_TRANSFORMERS);
    const message = inputType.fromObject(input);
    return inputType.encode(message).finish();
});
export const handleManagerForwardCall = ({ paramsOption, instance }) => __awaiter(void 0, void 0, void 0, function* () {
    const { contractAddress, methodName, args, caHash } = paramsOption || {};
    if (!(contractAddress && methodName && caHash)) {
        throw new Error('ManagerForwardCall parameter is missing');
    }
    const methods = yield getContractMethods(instance, paramsOption.contractAddress);
    // adjust some function, just like .CrossChainTransfer
    const _methodName = methodName.replace('.', '');
    const inputType = methods[_methodName];
    if (!inputType)
        throw new Error(`Contract ${contractAddress} does not exist ${methodName}`);
    const params = Object.assign({}, paramsOption);
    if (args)
        params.args = yield encodedParams(inputType, args);
    return params;
});
export const handleContractParams = (params) => __awaiter(void 0, void 0, void 0, function* () {
    const { paramsOption, functionName } = params;
    if (functionName === 'ManagerForwardCall')
        return handleManagerForwardCall(params);
    return paramsOption;
});
export const createManagerForwardCall = ({ rpcUrl, instance, paramsOption, caContractAddress, }) => __awaiter(void 0, void 0, void 0, function* () {
    const ManagerForwardCall = 'ManagerForwardCall';
    let _instance;
    if (rpcUrl)
        _instance = aelf.getAelfInstance(rpcUrl);
    if (instance)
        _instance = instance;
    if (!_instance)
        throw new Error('Please pass in instance or rpcUrl');
    const [managerForwardCall, caMethods] = yield Promise.all([
        handleManagerForwardCall({
            instance,
            functionName: ManagerForwardCall,
            paramsOption,
        }),
        getContractMethods(instance, caContractAddress),
    ]);
    const managerForwardCallInputType = caMethods[ManagerForwardCall];
    let input = AElf.utils.transform.transformMapToArray(managerForwardCallInputType, managerForwardCall);
    input = AElf.utils.transform.transform(managerForwardCallInputType, input, AElf.utils.transform.INPUT_TRANSFORMERS);
    const message = managerForwardCallInputType.fromObject(input);
    return AElf.utils.uint8ArrayToHex(managerForwardCallInputType.encode(message).finish());
});
